import React from 'react';
import { Empty, Page, Refreshable, Scrollbar } from 'codeArt/components/Base';
import { Container } from 'codeArt/components/Layout';
import Portal from 'codeArt/components/Portal';
import { Avatar } from 'codeArt/components/Avatar';
import StarBorderIcon from '@material-ui/icons/StarBorder';
import PermIdentityIcon from '@material-ui/icons/PermIdentity';
import ArrowRightOutlinedIcon from '@material-ui/icons/ArrowRightOutlined';
import { Board } from 'codeArt/external/components/Widget';
import { Html } from 'codeArt/components/Html';
import Button, { EditLink, ModalButton, SettingLink } from 'codeArt/components/Button';
import Modal, { Message } from 'codeArt/components/Modal';
import Form, { FormAction, FormCell, FormSection } from 'codeArt/components/Form';
import { TextBox } from 'codeArt/components/TextBox';
import { Notification, Request, Util } from 'codeArt/common';
import { Devices } from 'app/constant';
import AirplayIcon from '@material-ui/icons/Airplay';
import ModuleSide from 'codeArt/components/ModuleSide';
import { onComparatorChange } from 'actions/Comparator';
import { connect } from 'react-redux';

class _Comparator extends React.Component {

    constructor(props) {
        super(props);
        Comparator.current = this;//单例
    }

    open() {
        this.modal.open();
    }

    close() {
        this.modal.close();
    }

    tools() {
        let { readOnly } = this.props;
        if (readOnly) return null;
        return [
            <ModalButton key={"params"} color="blue" onClick={() => { this.leftBar.scrollTop(10); }}>参数设置</ModalButton>,
            <ModalButton key={"close"} color="grey" onClick={() => { this.close(); }}>关闭</ModalButton>
        ];
    }

    getDevices() {
        return [{
            field: "formingMachine",
            flex: 1,
            multiple: true,
            items: Devices.map((s) => { return { label: s.Name, value: s.Id, type: s.type, icon: AirplayIcon } })
        }];
    }

    render() {
        return (
            <Modal ref={(r) => { this.modal = r; }} title="设备比较器"
                // titleClassName="c-l0" horizontal
                containerClassName={"d-flex"}
                containerFull={true} size={"full"} tools={this.tools()}>

                <Panel />
            </Modal>
        )
    }
}


const mapStateToProps = ({ Comparator }) => {
    const { value } = Comparator;
    return { value };
};

export const Comparator = connect(mapStateToProps, { onComparatorChange })(_Comparator);


class Panel extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

        }

        this.top = 10;
    }

    render() {
        return (
            <div className="d-flex flex-column h-100 w-100">

                {/* 以下是x轴滚动条 其他x轴隐藏 由此滚动条进行总控制*/}
                <div className="c-panel-box" style={{ height: 17 }}>
                    <div ref={(r) => { this.xBar = r; }} onScroll={() => { this.bobyBar.scrollLeft = this.topBar.scrollLeft = this.xBar.scrollLeft; }} className={"c-panel-scrollX"} >
                        <div style={{ height: 1, width: 2200 }} />
                    </div>
                </div>

                <div className="d-flex flex-row h-100 w-100">
                    <div className="d-flex flex-column h-100 w-100">
                        <div className="d-flex flex-row">
                            <div className="d-flex flex-column" style={{ backgroundColor: "violet", height: 200, width: 200 }}>
                                231321321231321321231321321
                            </div>

                            <div className="c-panel-box">
                                <div ref={(r) => { this.topBar = r; }} className={"c-panel-scroll-hidden"} >
                                    <div className="d-flex flex-column" style={{ backgroundColor: "thistle", height: 200, width: 2000 }}>
                                        231321321231321321231321321
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="c-panel-box">
                            <div ref={(r) => { this.leftBar = r; }} className={"c-panel-scroll-hidden"}>
                                <div className="d-flex flex-row">

                                    <div className="d-flex flex-column" style={{ backgroundColor: "wheat", height: 1000, width: 200 }}>
                                        231321321231321321231321321231321321
                                    </div>

                                    <div className="c-panel-box" style={{ height: 1000, width: 2000 }}>
                                        <div ref={(r) => { this.bobyBar = r; }} className={"c-panel-scroll-hidden"}  >
                                            <div style={{ height: 1000, width: 2000, backgroundColor: "yellow" }}>
                                                3213123213231321321231321321
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>


                    {/* 以下是y轴滚动条 其他y轴隐藏 由此滚动条进行总控制*/}
                    <div className="c-panel-box" style={{ width: 17 }}>
                        <div ref={(r) => { this.yBar = r; }} onScroll={() => { this.leftBar.scrollTop = this.yBar.scrollTop; }} className={"c-panel-scrollY"} >
                            <div style={{ height: 2000, width: 1 }} />
                        </div>
                    </div>

                </div>
            </div>
        );
    }
}



{/* <div className="d-flex flex-column h-100 w-100">
<div className="d-flex flex-row">
    <div className="d-flex flex-column" style={{ backgroundColor: "violet", height: 200, width: 200 }}>
        231321321231321321231321321
    </div>
    <Scrollbar overflowY={"hidden"} autoHide={false} horizontal={true}  ref={(r) => { this.topBar = r; }} onScrollFrame={(v) => { this.bobyBar.scrollLeft(this.topBar.getScrollLeft()); }}>
        <div className="d-flex flex-column" style={{ backgroundColor: "thistle", height: 200, width: 2000 }}>
            231321321231321321231321321
        </div>
    </Scrollbar>
</div>

<Scrollbar ref={(r) => { this.leftBar = r; }}>
    <div className="d-flex flex-row w-100 h-100">
        <div className="d-flex flex-column" style={{ backgroundColor: "wheat", height: 1000, width: 200 }}>
            231321321231321321231321321231321321
        </div>
        <Scrollbar overflowY={"hidden"} ref={(r) => { this.bobyBar = r; }}>
            <div style={{ height: 500, width: 2000, backgroundColor: "yellow" }}>
                3213123213231321321231321321
            </div>
            <div style={{ height: 500, width: 1000, backgroundColor: "violet" }}>
                3213123231321321231321321
            </div>
        </Scrollbar>
    </div>
</Scrollbar>
</div> */}